/* eslint-disable react-hooks/exhaustive-deps */
// utils
import { findIndex, forEach, get, isEmpty, isNumber } from "lodash";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// apis
import {
  createEmployeeInGroups, createGroupsOrganize, deleteEmployeeInGroups, deleteGroups, getGroups, modifyEmployeeInGroups
} from "../../../apis/companies/group";
import emptyUserImage from "../../../assets/images/empty-user-img.png";
import GroupImage from "../../../assets/images/icon/custom-tree/file-icon.svg";
// Icon
import AddDocIcon from "../../../assets/images/person/add-doc-icon.svg";
import ArrowBottomIcon from "../../../assets/images/person/arrow-bottom-icon.svg";
import ArrowTopIcon from "../../../assets/images/person/arrow-top-icon.svg";
import PencilIcon from "../../../assets/images/person/pencil-icon.svg";
import TrashIcon from "../../../assets/images/person/trash-icon.svg";
import IconButton from "../../../components/Button/IconButton";
import Input from "../../../components/Input";
// component
import PersonTreeTable from "../../../components/PersonTreeTable";
import { getStoreCompanies } from "../../../store/actions";
import { preventEvent } from "../../../utils/element";
import { employeePreview, searchEmployee } from "../../../utils/employee";
import { sortByKey } from "../../../utils/sort";
import { toast } from "../../../utils/toast";
// Page
import Group from "../Component/Group";

const GroupsView = ({ type = "group", mode, isTax = false }) => {
  const dispatch = useDispatch();
  const {
    employees,
    storeGroups,
    storeManagerGroups,
  } = useSelector(
    (store) => ({
      employees: store.Data.employees,
      storeGroups: store.Data.groups,
      storeManagerGroups: store.Data.managerGroups,
    }),
    shallowEqual
  );
  const [treeData, setTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    name: "",
    employees: [],
  });
  const [defaultSelected, setDefaultSelected] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [isFirst, setIsFirst] = useState(true);
  // 상세 화면 state
  const [groupOpen, setGroupOpen] = useState(false);
  const [groupData, setGroupData] = useState({});
  const [formMode, setFormMode] = useState("create");
  // 직원 등록
  const [targetEmployee, setTargetEmployee] = useState([]);
  const [groupTableFields, setGroupTableFields] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    setGroups(isTax ? storeManagerGroups : storeGroups);
  }, [isTax, storeGroups, storeManagerGroups]);

  useEffect(() => {
    setGroupTableFields([
      {
        key: "name",
        width: "40%",
        onValue: (value, field, data) => {
          const { partName, name, profileImg } = data;
          return (
            <div className="user-wrap">
              <div className="profile-container" onClick={(e) => showPreviewEmployee(e, data)}>
                <div className="profile-img-wrap">
                  <img src={profileImg || emptyUserImage} alt={data.name} />
                </div>
                <span className="name">{name}</span>
              </div>
              <span className="part">{partName}</span>
            </div>
          );
        },
      },
      {
        title: "역할",
        key: "role",
        width: "22%",
        className: "part-name",
        onValue: (value, field, data) => {
          const { role, idx } = data;
          let inputValue = "";

          return mode === "modify" ? (
            <>
              <Input
                className="role-input"
                placeholder="역할"
                defaultValue={role}
                onChange={(e) => {
                  inputValue = e.target.value;
                }}
              />
              <IconButton
                icon={PencilIcon}
                onClick={() => handleUpdateEmployee(idx, inputValue)}
              />
            </>
          ) : (
            <div className="part-name">{role}</div>
          );
        },
      },
      {
        key: "email",
        width: "38%",
        className: "email",
      },
    ]);
  }, [mode, isTax]);

  useEffect(() => {
    submit();
  }, [groups]);

  // 트리 데이터 생성
  const submit = () => {
    setIsLoading(true);
    let treeData = [];

    if (!isEmpty(groups)) {
      sortByKey(groups, "sort");
      treeData = [
        ...groups.map(({ idx, name, sort }) => ({
          title: name,
          key: idx,
          sort,
          icon: GroupImage
        })),
      ];
    }
    setIsLoading(false);
    setTreeData(treeData);
    if (isFirst && !isEmpty(treeData)) {
      setSelectedData(treeData[0] || {});
      matchEmployeeInGroups(get(groups, "[0].idx"));
      setDefaultSelected([get(groups, "[0].idx")]);
    }
    setIsFirst(false);
    setSelectedData((oldVal) =>
      treeData.find((data) => get(data, "key") === get(oldVal, "key"))
    );
  };

  // 선택 액션
  const onSelect = (keys, event) => {
    const { node, selected } = event;
    if (selected) {
      setSelectedData(node);
      matchEmployeeInGroups(node.key);
    } else {
      setSelectedData({});
      setTableData({});
    }
  };

  // 그룹에 직원 매칭
  const matchEmployeeInGroups = (idx) => {
    if (!isNumber(idx)) return;
    getGroups(idx, { isTax }).then((res) => {
      const { name, companyGroupEmployees } = res.data.group;
      setTableData({
        name: name,
        employees: companyGroupEmployees.map((employee) => ({
          idx: get(employee, "employeeIdx"),
          name: get(employee, "employee.name"),
          partName: (employees.find(e => e.idx === get(employee, "employeeIdx")) || {}).partName || "",
          gradeName: (employees.find(e => e.idx === get(employee, "employeeIdx")) || {}).gradeName || "",
          code: (employees.find(e => e.idx === get(employee, "employeeIdx")) || {}).code || "",
          profileImg: employees.find(e => e.idx === get(employee, "employeeIdx", {}))?.profileImg || "",
          role: employee.role,
          sort: employee.sort,
          office: employee.employee?.office
        })),
      });
    });
  };

  // 그룹 추가
  const handleAddAction = () => {
    if (!isEmpty(treeData)) {
      if (isEmpty(selectedData)) {
        return toast.error("등록할 그룹의 상위 그룹을 선택해주세요.");
      }
      setGroupOpen(true);
      setFormMode("create");
    } else {
      setGroupOpen(true);
      setFormMode("create");
    }
  };

  // 그룹 수정
  const handleEditAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 그룹이 없습니다.");
    }
    setGroupOpen(true);
    setFormMode("modify");
    setGroupData(selectedData);
  };

  // 그룹 삭제
  const handleDeleteAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 그룹이 없습니다.");
    }
    const _treeData = treeData;
    const changeData = _treeData.filter(
      (data) => data.sort > selectedData.sort
    );
    const orgData = {
      groups: changeData.map((group) => ({
        groupIdx: group.key,
        sort: group.sort - 1,
      })),
      isTax
    };

    deleteGroups(get(selectedData, "key"), { isTax }).then(() => {
      createGroupsOrganize(orgData).then(() => {
        setTableData({});
        dispatch(getStoreCompanies());
      });
    });
  };

  // 그룹 위로
  const handleTopAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 그룹이 없습니다.");
    }
    const oldIndex = findIndex(treeData, (d) => d.key === selectedData.key);
    const newIndex = oldIndex - 1;
    if (oldIndex === 0) return;
    setTreeData([...moveArrayItemToNewIndex(treeData, oldIndex, newIndex)]);
    reOrganizeGrades();
  };

  // 아래로
  const handleBottomAction = () => {
    if (isEmpty(selectedData)) {
      return toast.error("선택된 그룹이 없습니다.");
    }
    const oldIndex = findIndex(treeData, (d) => d.key === selectedData.key);
    const newIndex = oldIndex + 1;
    const lastIndex = treeData.length - 1;
    if (oldIndex === lastIndex) return;
    setTreeData([...moveArrayItemToNewIndex(treeData, oldIndex, newIndex)]);
    reOrganizeGrades();
  };

  // 그룹 개편하기
  const reOrganizeGrades = () => {
    const form = {
      groups: treeData.map((group, idx) => ({
        groupIdx: group.key,
        sort: idx,
      })),
      isTax
    };

    createGroupsOrganize(form)
      .then(() => {
        dispatch(getStoreCompanies());
      })
      .catch(() => { });
  };

  // 인덱스 변경
  const moveArrayItemToNewIndex = (arr, old_index, new_index) => {
    let orginArr = arr;
    if (new_index >= orginArr.length) {
      let k = new_index - orginArr.length + 1;
      while (k--) {
        orginArr.push(undefined);
      }
    }
    orginArr.splice(new_index, 0, orginArr.splice(old_index, 1)[0]);
    return orginArr;
  };

  const IconButtons = [
    { icon: AddDocIcon, action: handleAddAction },
    { icon: PencilIcon, action: handleEditAction },
    { icon: ArrowTopIcon, action: handleTopAction },
    { icon: ArrowBottomIcon, action: handleBottomAction },
    { icon: TrashIcon, action: handleDeleteAction },
  ];

  const handleDeleteEmployee = (data) => {
    deleteEmployeeInGroups(selectedData.key, data.idx, {
      isTax,
    }).then(() => {
      matchEmployeeInGroups(selectedData.key);
    });
  };

  const handleAddEmployee = () => {
    searchEmployee(
      (employees) => {
        setTargetEmployee(employees);
      },
      targetEmployee,
      { isTax },
    );
  };

  const handleUpdateEmployee = (idx, inputValue) => {
    modifyEmployeeInGroups(selectedData.key, idx, {
      role: inputValue,
      isTax,
    }).then(() => {
      matchEmployeeInGroups(selectedData.key);
    });
  };

  const showPreviewEmployee = (e, _data) => {
    preventEvent(e);
    employeePreview(_data.idx);
  };

  useEffect(() => {
    if (!isEmpty(targetEmployee) && !isEmpty(selectedData)) {
      const promiseList = [];
      forEach(targetEmployee, employee => {
        promiseList.push(createEmployeeInGroups(selectedData.key, {
          employeeIdx: employee.idx,
          role: "",
          sort: 0,
          isTax,
        }));
      });

      Promise.all(promiseList)
        .then(() => {
          matchEmployeeInGroups(selectedData.key);
          setTargetEmployee([]);
        });
    }
  }, [targetEmployee, selectedData]);

  return (
    <>
      <PersonTreeTable
        type={type}
        mode={mode}
        submit={submit}
        isLoading={isLoading}
        treeData={treeData}
        setTreeData={setTreeData}
        onSelect={onSelect}
        defaultSelectedKeys={defaultSelected}
        selectedData={selectedData}
        buttons={IconButtons}
        tableFields={groupTableFields}
        tableData={tableData}
        handleAddEmployee={handleAddEmployee}
        handleDeleteEmployee={handleDeleteEmployee}
      />
      <Group
        open={groupOpen}
        setOpen={setGroupOpen}
        list={groupData}
        mode={formMode}
        treeData={treeData}
        preSort={get(selectedData, "sort")}
        submit={matchEmployeeInGroups}
        isTax={isTax}
      />
    </>
  );
};

export default GroupsView;
